<template>
    <v-card raised class="mb-4">
        <v-layout row wrap>
        <v-flex xs12 md6>
            <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
            <v-flex d-flex xs8 class="font-weight-bold" >{{preReg.VehicleNo}} - {{preReg.VehicleLicensePlateNo}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
            <v-flex d-flex xs8>{{preReg.Facility}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.ArticleNo}} - {{preReg.ArticleName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.CarrierNo}} - {{preReg.CarrierName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(preReg)}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
            <v-flex d-flex xs8>{{preReg.Comment1}}</v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 md6>
            <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.PlantNo}} - {{preReg.PlantName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.AgreementNo}} - {{preReg.AgreementName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.DeliveryNo}} - {{preReg.DeliveryName}}</v-flex>
            </v-layout>
            <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
            <v-flex d-flex xs8>{{getWeightStr(preReg)}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
              <v-flex d-flex xs8>{{preReg.RequisitionNo1}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
              <v-flex d-flex xs8>{{preReg.RequisitionNo2}}</v-flex>
            </v-layout>
        </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions style="padding: 0px 0px 0px 0px" v-if="preReg.FinishedBy != null || preReg.Completed">
            <v-flex xs6>
            <div style="padding: 0px 0px 0px 10px">{{$t("PreStatus" + preReg.PreStatus)}}</div>
            </v-flex>
            <v-flex xs6 text-right>
            <v-btn class="mr-1 mb-1" @click="printRegistration(preReg.Id)" color="primary" :disabled="!preReg.Completed">
                {{$t("Print")}}
            </v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
import * as Security from '@/core/security'

export default {
  props: ['preReg'],
  data () {
    return {
      hiddenFields: []
    }
  },
  methods: {
    getCustomerStr (preReg) {
      if (preReg.CustomerNo && preReg.CustomerName) { return preReg.CustomerNo + ' - ' + preReg.CustomerName } else if (preReg.CustomerNo) { return preReg.CustomerNo } else if (preReg.CustomerName) { return preReg.CustomerName } else { return '' }
    },
    getWeightStr (preReg) {
      if (preReg && preReg.CreatedBy.startsWith('corp:')) {
        // Weighing is via weightbridge
        if (preReg.Completed) {
          return preReg.WeightNet + ' kg'
        } else {
          return preReg.WeightFirst + ' kg (' + this.$t('WeightFirst') + ')' // Vehicle has only done a first weighing
        }
      } else {
        // Weighing is via wheelloader
        return Math.abs(preReg.WeightNet) + ' kg'
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    }
  },
  async mounted () {
    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
  }

}
</script>
